import logo from './img/logo.png';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'

const About = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1><FontAwesomeIcon className='info-icon' icon={solid('circle-info')} /> About Diamond Client</h1>
          <img src={logo} className="App-logo" alt="logo" />
        <p>
          Diamond Client is a Minecraft client made under the company name Biasa Adja. Diamond Client offers you a lot of mods and features. We made Diamond Client for you to use with ease.
        </p>
        <a
          className="download"
          href="https://github.com/ProKocak28/diamondclient-assets/releases/latest" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          {/* <button className='download-button'><FontAwesomeIcon className='download-button-icon' icon={solid('download')} /> Download Diamond Client Now!</button> */}
        </a>
      </header>
    </div>
  );
}

export default About;
